import { COLOR_PALETTE } from 'constants/ui';

export const listStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const rowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  padding: '12px 14px',
  borderRadius: '10px',
  // Dark: the light pale BLUE[1] running-state banner reads near-white on the dark canvas; use the
  // accent soft tint + accent border. Light keeps the original pale-blue surface.
  border: ({ palette }) =>
    `1px solid ${palette.mode === 'dark' ? palette.primary.main : COLOR_PALETTE.BLUE[2]}`,
  backgroundColor: ({ palette }) =>
    palette.mode === 'dark' ? palette.primary.soft : COLOR_PALETTE.BLUE[1],
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: ({ palette }) =>
      palette.mode === 'dark' ? palette.background.hoverHighlight : COLOR_PALETTE.BLUE[2],
  },
};

export const rowLeadingStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flex: 1,
  minWidth: 0,
};

// Pulsing accent dot that signals the run is actively working, distinguishing a
// live row from the static run-history rows. Reduced-motion users get the static
// dot (the accent color already reads as "active").
export const liveDotStyles = {
  width: '8px',
  height: '8px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: ({ palette }) => palette.primary.main,

  '@keyframes liveCardPulse': {
    '0%, 100%': { opacity: 1, transform: 'scale(1)' },
    '50%': { opacity: 0.35, transform: 'scale(0.8)' },
  },
  animation: 'liveCardPulse 1.6s ease-in-out infinite',

  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};

export const rowBodyStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
  flex: 1,
  minWidth: 0,
};

export const rowTitleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  minWidth: 0,
};

export const rowTitleTextStyles = {
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const rowMetaStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: ({ palette }) => palette.text.dark,
  flexWrap: 'wrap',
};

export const dotSeparatorStyles = {
  display: 'inline-block',
  width: '3px',
  height: '3px',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: COLOR_PALETTE.GRAY[6],
};

export const rowTrailingStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  flexShrink: 0,
};
